"use strict";

var _slicedToArray = require("/vercel/path0/react/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rebound_1 = require("rebound");

var react_1 = require("react");

var useSpring = function useSpring() {
  var targetValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var tension = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
  var friction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;

  var _react_1$useState = react_1.useState(null),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      spring = _react_1$useState2[0],
      setSpring = _react_1$useState2[1];

  var _react_1$useState3 = react_1.useState(targetValue),
      _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
      value = _react_1$useState4[0],
      setValue = _react_1$useState4[1];

  react_1.useEffect(function () {
    var listener = {
      onSpringUpdate: function onSpringUpdate(spring) {
        var value = spring.getCurrentValue();
        setValue(value);
      }
    };

    if (!spring) {
      var newSpring = new rebound_1.SpringSystem().createSpring(tension, friction);
      newSpring.setCurrentValue(targetValue);
      setSpring(newSpring);
      newSpring.addListener(listener);
      return;
    }

    return function () {
      spring.removeListener(listener);
      setSpring(null);
    };
  }, [tension, friction]);
  react_1.useEffect(function () {
    if (spring) {
      spring.setEndValue(targetValue);
    }
  }, [targetValue]);
  return value;
};

exports.default = useSpring;